import React, { useState } from "react";
import { Link } from "react-router-dom";
import { magazines } from "../../utils/magazine";
import ReactGA from "react-ga4";
import { mdiChevronDown, mdiChevronUp } from "@mdi/js";
import Icon from "@mdi/react";

const INITIAL_PREVIOUS_COUNT = 9;
const EXPANDED_PREVIOUS_COUNT = magazines.filter((magazine) => !magazine.isLatest).length;

export default function MagazinePage() {
  const [showAllPrevious, setShowAllPrevious] = useState(false);
  const latestMagazines = magazines.filter(
    (magazine) => magazine.isLatest
  );

  const previousMagazines = magazines
    .filter((magazine) => !magazine.isLatest)
    .sort(
      (a, b) =>
        new Date(b.publishedAt).getTime() -
        new Date(a.publishedAt).getTime()
    );
  const visiblePreviousMagazines = previousMagazines.slice(
    0, showAllPrevious
    ? EXPANDED_PREVIOUS_COUNT
    : INITIAL_PREVIOUS_COUNT
  );
  const hasMorePreviousIssues = previousMagazines.length > INITIAL_PREVIOUS_COUNT;
  const handleMagazineOpen = (
    slug: string,
    language: "en" | "cn"
  ) => {
    ReactGA.event("magazine_open", {
      slug,
      language,
    });
  };

  return (
    <main className="magazine-page">
      <div className="magazine-page__container">
        {/* Page heading */}
        <header className="magazine-page__header">
          <h1>Magazines</h1>
          <p>
            Explore stories and ideas curated to inspire your next journey.
          </p>
        </header>

        {/* Latest Issues */}
        <section className="magazine-page__latest">
          <h2 className="magazine-page__section-title">
            Latest Issues
          </h2>

          <div className="magazine-page__latest-grid">
            {latestMagazines.map((magazine) => (
              <article
                key={magazine.slug}
                className="magazine-latest-card"
              >
                <Link
                  to={`/web/magazine/${magazine.slug}`}
                  className="magazine-latest-card__cover"
                  onClick={() =>
                    handleMagazineOpen(magazine.slug, magazine.language)
                  }
                >
                  <img
                    src={magazine.coverImage}
                    alt={magazine.title}
                  />
                </Link>

                <div className="magazine-latest-card__content">
                  <h3>{magazine.title}</h3>
                  <p>
                    Discover autumn's most inspiring destinations –
                    seasonal escapes...
                  </p>
                  <time dateTime={magazine.publishedAt}>
                    {new Date(
                      magazine.publishedAt
                    ).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </time>

                  <Link
                    to={`/web/magazine/${magazine.slug}`}
                    className="magazine-latest-card__button"
                    onClick={() =>
                      handleMagazineOpen(magazine.slug, magazine.language)
                    }
                  >
                    Read the issue
                    <img className="magazine-latest-card__button__icon"
                      src="/iceholidays-assets/images/icons/arrow-right-white.png"
                      alt=""
                    />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
      {previousMagazines.length > 0 && (
        <div className="magazine-page__content">
          {/* Previous Issues */}
          <section className="magazine-page__previous">
            <div className="magazine-page__previous-container">
              <h2 className="magazine-page__section-title border-left-0 padding-left-0">
                Previous Issues
              </h2>

              <div className="magazine-page__previous-grid">
                {visiblePreviousMagazines.map((magazine) => (
                  <article
                    key={magazine.slug}
                    className="magazine-previous-card"
                  >
                    <Link
                      to={`/web/magazine/${magazine.slug}`}
                      className="magazine-previous-card__cover"
                      onClick={() =>
                        handleMagazineOpen(magazine.slug, magazine.language)
                      }
                    >
                      <img
                        src={magazine.coverImage}
                        alt={magazine.title}
                      />
                    </Link>

                    <div className="magazine-previous-card__content">
                      <h3>{magazine.title}</h3>

                      <p>
                        Explore the latest trends and insights in the
                        world of design and travel...
                      </p>

                      <time dateTime={magazine.publishedAt}>
                        {new Date(
                          magazine.publishedAt
                        ).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })}
                      </time>
                    </div>
                  </article>
                ))}
              </div>

              {hasMorePreviousIssues && (
                <div className="magazine-page__view-more">
                  <button
                    type="button"
                    onClick={() =>
                      setShowAllPrevious((current) => !current)
                    }
                  >
                    {showAllPrevious ? "Show Less" : "Show More"}
                    <Icon
                      path={showAllPrevious ? mdiChevronUp : mdiChevronDown}
                      size="24px"
                    />
                  </button>
                </div>
              )}
            </div>
          </section>
        </div>
      )}
    </main>
  );
}